var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllCat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 94,
    viewBox: "0 0 116 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.154138 16.4652C-0.144282 13.7679 1.0494 12.5692 3.73518 12.5692H12.0909V3.87804C12.0909 1.78018 13.583 0.581407 15.9704 0.581407C32.9804 -0.317675 47.3045 2.67926 57.4508 15.2664C67.5971 2.67926 81.9213 -0.317675 99.2296 0.581407C101.617 0.581407 102.811 1.78018 103.109 3.87804V12.5692H111.166C114.151 12.5692 115.344 13.7679 115.046 16.4652V90.1899C114.151 94.086 111.465 94.6854 107.884 92.8872C89.6802 86.5936 73.2671 88.0921 57.4508 93.4866C41.933 88.0921 25.5199 86.5936 7.31622 92.8872C3.43676 94.6854 1.0494 94.086 0.154138 90.1899V16.4652ZM7.61464 20.3612V85.0951C18.0593 81.1991 38.3519 80.5997 45.2156 82.3979C41.0377 77.0034 25.2214 74.9055 15.9704 75.2052C12.6878 75.5049 12.0909 73.4071 12.0909 69.5111V20.3612H7.61464ZM107.287 20.3612L107.585 85.0951C97.1407 81.1991 76.5497 80.5997 69.686 82.3979C73.8639 77.0034 89.9786 74.9055 99.2296 75.2052C102.214 75.5049 103.109 73.4071 103.109 69.5111V20.3612H107.287ZM95.3502 8.07376C81.3244 6.87498 69.0892 11.0707 61.3303 22.7588V78.8016C71.775 69.8107 83.4134 66.8138 95.3502 68.612V8.07376ZM19.5514 8.07376C33.8756 6.87498 45.8124 11.0707 53.8698 22.7588V78.8016C43.1266 69.8107 31.7867 66.8138 19.8499 68.612L19.5514 8.07376Z",
    fill: "#E3BA72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllCat);
export default __webpack_public_path__ + "static/media/all-cat.0a78cb7956fe4e8622f49dcd60deec3b.svg";
export { ForwardRef as ReactComponent };